import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IDhlDeReturnsCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class DhlDeReturnsCredentialsStore implements ICredentialsStore {
    private _changes: IDhlDeReturnsCredentialsModel = {} as IDhlDeReturnsCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get username() { return this._changes.username; };
    public get password() { return this._changes.password; };

    setUsername(value: string) {
        this._changes.username = value;
    };

    setPassword(value: string) {
        this._changes.password = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default DhlDeReturnsCredentialsStore;
